import { useEffect, useState } from 'react';
import {
  SingleTicketTransformed,
  SingleTicketInitial,
} from 'src/components/Tickets/models/Tickets.interface';
import axios from 'axios';

export const useGetTicketInfo = (axsTicketId: string | number) => {
  const [ticketData, setTicketData] = useState<SingleTicketInitial | null>(
    null
  );
  const [loadingTicket, setLoadingTicket] = useState<boolean>(false);
  const [formattedTicketData, setFormattedTicketData] =
    useState<Partial<SingleTicketTransformed> | null>(null);

  const getTicketData = async () => {
    try {
      setLoadingTicket(true);
      const { data } = await axios.get(`api/tickets/${axsTicketId}`);
      if (data) {
        setTicketData(data);
        const formattedData = {
          ...data,
          owner: data?.owner.fullname,
        } as Partial<SingleTicketTransformed>;

        setFormattedTicketData(formattedData);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingTicket(false);
    }
  };

  useEffect(() => {
    getTicketData();
  }, [axsTicketId]);

  return {
    ticketData,
    formattedTicketData,
    loadingTicket,
  };
};
